
import $ from 'jquery'
import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css';
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

mapboxgl.accessToken = 'pk.eyJ1IjoiZmxpcHBkZXZzIiwiYSI6ImNrc2hxc2x0ZDF3eGQyb29hZDNndWhuZXcifQ.NLQN5AjdofpVMB8SBRgDgA';

let query = window.location.search;

if( $( '.community-map' ).length ) {
  
  var calgary = [-114.07988955094518, 51.0528988784464];
  var edmonton = [-113.5818812957991, 53.471974386087425];
  const map2 = new mapboxgl.Map({
    container: 'community-map',
    style: 'mapbox://styles/flippdevs/cm7jomxtr00l501so85si771d',
    center: calgary,
    zoom: 9
  });

  map2.on('idle',function(){
    map2.resize()
  })
  // disable map zoom when using scroll
  map2.scrollZoom.disable();

  const nav = new mapboxgl.NavigationControl({
  showCompass: false
  });

  map2.addControl(nav, 'bottom-right');

  gsap.registerPlugin( ScrollTrigger );

  ScrollTrigger.create({
    trigger: '.communities-map-container',
    pin: '#community-map',
    start: 'top top+=50',
    end: 'bottom bottom-=50',
    // markers: true,
  }); 

  // map2.on('load', () => {

  //   map2.setLayoutProperty('calgary-se','visibility','visible');

  // })
  const layers = ['calgary-se', 'calgary-sw', 'calgary-ne', 'calgary-nw', 'beaumont', 'spruce-grove', 'edmonton-se'];

  function toggleLayer(activeLayer) {
    // Hide all layers
    layers.forEach(layer => {
      if (map2.getLayer(layer)) {
        map2.setLayoutProperty(layer, 'visibility', 'none');
      }
    });
  
    // Show only the clicked layer
    if (map2.getLayer(activeLayer)) {
      map2.setLayoutProperty(activeLayer, 'visibility', 'visible');
    }
  }

  const mapLegend = document.querySelectorAll( '.community-cpt' );

  mapLegend.forEach( ( legend, index ) => {

    var logo = legend.dataset.logo
    var city = legend.dataset.city;
    var district = legend.dataset.district;
    var long = legend.dataset.long;
    var lat = legend.dataset.lat;
    let name = legend.dataset.name;
    let slug = legend.dataset.slug;
    let showhome = legend.dataset.showhome;
    let homes = legend.dataset.homes;
    var title = $( '.community-title' )[index].innerHTML;
    var el = document.createElement('div');

    // create the popup
    const popup = new mapboxgl.Popup({ focusAfterOpen: false })
    .setHTML(
      `
      <div class="title-content flex-column flex-center">      
        ${ !! logo && logo ? 
            `<img class="mb-16" src="${ logo }" alt="logo for ${ name }" />` : ""} 
        ${ showhome == "true" && showhome ? 
            `<p class="showhome-tag p bold mb-12">Showhome available</p>` : ""} 
        ${typeof homes !== "undefined" && homes ? 
            `<p class="p bold">Home types: </p>
            <p class="p mb-24">${homes}</p>` : ""}            
        <a class="text-navy community-link flex-btwn flex-aligned" href="/community/${ slug }">View Community</a>
      </div>
      `
      );

    const marker = new mapboxgl.Marker( el ).setLngLat([long, lat]).setPopup(popup).addTo(map2);

    el.className = 'marker';

    el.addEventListener( 'click', function() {
      $( '.community-cpt' ).removeClass( 'active' )
      $( '.map .marker' ).removeClass( 'active' )
      $( legend ).addClass( 'active' )
      $( el ).addClass( 'active' )
      popup.addTo(map2);
      toggleLayer( district )
    });
    
    el.addEventListener( 'mouseenter', function() {
      $( '.community-cpt' ).removeClass( 'active' )
      $( '.map .marker' ).removeClass( 'active' )
      $( legend ).addClass( 'active' )
      $( el ).addClass( 'active' )
      toggleLayer( district )
    });

    legend.addEventListener('mouseenter', function () {
      $('.community-cpt').removeClass('active');
      $('.map .marker').removeClass('active');
      $(legend).addClass('active');
      $(el).addClass('active');
      $('.mapboxgl-popup').remove(); // Remove all existing popups
      // popup.addTo(map2);
      toggleLayer( district )

      if( city == 'edmonton' ) {

        map2.flyTo({
          center: edmonton, 
          zoom: 8.85, 
          animate: false,
        });
      } else {
        map2.flyTo({
          center: calgary, 
          zoom: 9,
          animate: false, 
        });
      }
    });
  })
}

if( $( '.lot-map' ).length ) {
  let expandButton = document.querySelector( '.lot-expand' );
  let closeButton = document.querySelector( '.lot-close' );
  let lotMap = document.querySelector( '.lot-wrapper' );

  $( expandButton ).on( 'click', () => {
    $( lotMap ).addClass( 'full-screen' );
    $( closeButton ).show();
    $( 'body' ).addClass( 'no-scroll' );
  } )

  $( closeButton ).on( 'click', () => {
    $( lotMap ).removeClass( 'full-screen' );
    $( closeButton ).hide();
    $( 'body' ).removeClass( 'no-scroll' );
  } )
}